import {
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	ViewChild,
	ViewChildren,
	QueryList,
	SimpleChanges,
} from '@angular/core';
import { MatLegacyAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/legacy-autocomplete';
import { FormArray, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { State } from '@state/core.state';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import {
	IS_NULL_OR_UNDEFINED,
	Owner,
	IS_NOT_NULL_OR_UNDEFINED,
	SelectedDateRange,
	IS_NOT_EMPTY,
	RestService,
	GET_CARRIER_BUSINESS_NAME,
} from 'cargo-chief-commons';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { UtilService } from '@service/util/util.service';
import { ProjectHelperService } from '@service/projectHelper/project-helper.service';
import { ProductsService } from '@service/products/products.service';
import { PROJECT_FIELDS, PROJECT_STAGES } from '../../v2/project/projects-list/constants';
import { PROJECT_TYPES } from '@domain/constants/project-types';
import { MtxPopoverTrigger } from '@ng-matero/extensions/popover';
import {
	OPERATOR_OPTIONS,
	OPERATORS,
	LOAD_VOLUME_DURATION,
	INPUT_TYPES,
	LOCATION_OPERATORS_LABEL,
	STAGE_OPERATORS_LABEL,
	ARCHIVED_OPERATORS_LABEL,
	JOB_STATUS_OPERATORS_LABEL,
	EQUAL_NOT_EQUAL_TYPES_LABEL,
	PROJECT_OPERATORS_LABEL,
} from './constants';
import { USA_STATES } from '@domain/constants/usa-states';
import { AUTOMATION_LOADS } from 'app/broker/automation/loads/store/actions';
import { USER_SORTS_AND_FILTERS_TYPE } from '@domain/constants/app-variables';

import {
	BULK_CAPACITY_MATCH_JOBS_STATUS,
	LOADS_AUTOMATION_FIELDS,
} from 'app/broker/automation/loads/loads/constants';
import { IMPORT_STATS_JOBS_STATUS } from 'app/broker/automation/utils/import-stats-constants';

import { Router } from '@angular/router';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { UrlService } from '@service/url/url.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmTextDialogComponent } from '../confirm-text-dialog/confirm-text-dialog.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
	selector: 'app-tabbed-table',
	templateUrl: './tabbed-table.component.html',
	styleUrls: ['./tabbed-table.component.scss'],
})
export class TabbedTableComponent implements OnInit, OnChanges, AfterViewInit {
	@ViewChild(MatPaginator) paginator: MatPaginator;
	// actions input
	@Input() showAddProjectsButton: boolean = false;
	@Input() showImportProjectsButton: boolean = false;
	@Input() showImportLoadsButton: boolean = false;
	@Input() showImportTransactionsButton: boolean = false;
	@Input() showImportCarrierButton: boolean = false;
	@Input() showImportRFPButton: boolean = false;
	@Input() disableActions: boolean = true;

	@Input() showUpdateViewButton: boolean = true;
	@Input() showSaveViewButton: boolean = true;
	@Input() showFilterButton: boolean = true;
	@Input() showSortButton: boolean = true;
	@Input() showActionButton: boolean = true;
	@Input() rowSelectableEnabled: boolean = true;
	@Input() selectAllEnabled: boolean = true;
	@Input() actionTextDescriptions: string[] = [];
	@Input() waitingMessage: string = null;

	@Input() importLoads: (args: any) => void;
	@Input() importTransactions: (args: any) => void;
	@Input() importRFPs: (args: any) => void;

	@Input() links: string[] = [];
	@Input() activeLink: string;
	@Input() customTabId: number;
	@Input() actions = [];
	@Input() data: Array<Object> = [];
	@Input() dataType: string = 'data';
	@Input() headers: Array<{ dataName: string; formattedName: string; action?: (element) => void }> =
		[];
	@Input() displayedColumns: string[] = [];
	@Input() dataTypes: string[] = [];
	@Input() fieldMap: Object;
	@Input() filterFields: string[];
	@Input() filterFieldsInputTypeMap: Map<string, string> = new Map<string, string>();
	@Input() sortFields: string[];
	@Input() isStaticData: boolean = true;
	@Input() loadingData: boolean = false;
	@Input() totalNumberOfRecords: number = 0;
	@Input() activeUsersList: Array<Owner> = [];
	@Input() usersListPlaceholder: string = 'Assigned To';
	@Input() showPreviousDates: boolean = false;
	@Input() showScorecardRange: boolean = false;
	@Input() showTabBars: boolean = true;
	@Input() rowClasses: string = '';
	@Input() rowOnClickEnabled: boolean = false;
	@Input() showFooterText: boolean = false;
	@Input() footerText!: string;
	@Input() showPostLoadButton: boolean = false;
	@Input() userSortsAndFiltersType!: string;
	@Input() isActiveTab: boolean = false;
	@Input() isOpenTab: boolean = false;
	@Input() isBookedTab: boolean = false;
	@Input() isFullWidthActionRow: boolean = false;
	@Input() disableTabNavPagination: boolean = false;
	@Input() rowOnClick: (args: any) => void;
	@Input() postLoadOnClick: () => void;

	@Input() rowCheckboxIsDisabled: (args: any) => boolean;
	@Input() rowOnSelect: (args: any, state: boolean) => void;
	@Input() getUserSortsAndFilters: () => void;

	@Output() updateData: EventEmitter<string> = new EventEmitter();
	@Output() pageEvent: EventEmitter<{ page: number; pageSize: number }> = new EventEmitter();
	@Output() emitClearFilter: EventEmitter<string> = new EventEmitter();
	@Output() emitClearSort: EventEmitter<string> = new EventEmitter();
	@Output() emitFilter: EventEmitter<Array<Object>> = new EventEmitter();
	@Output() emitSort: EventEmitter<Array<Object>> = new EventEmitter();
	@Output() importData: EventEmitter<string> = new EventEmitter();
	@Output() createData: EventEmitter<string> = new EventEmitter();
	@ViewChildren(MtxPopoverTrigger) triggers: QueryList<MtxPopoverTrigger>;

	PAGE_SIZE_OPTIONS = [25, 50, 100];
	AND = 'and';
	OR = 'or';
	FIRST_TO_LAST = 'asc';
	LAST_TO_FIRST = 'desc';

	defaultCondition = 'and';
	defaultDirection = 'asc';

	filterState = '';
	sortState = '';

	isActionbuttonDisabled = true;

	isAddConditionActive: boolean = false;
	isFilterButtonActive: boolean = false;
	filterForm: FormGroup;

	isAddFieldActive: boolean = false;
	isSortButtonActive: boolean = false;
	sortForm: FormGroup;

	dataSource: MatTableDataSource<Object>;
	selection = new SelectionModel<Object>(true, []);

	trailerTypes: any[] = [];
	selectedUsers = [];
	minimumDate = new Date();
	locationModel = {};
	filterOptions: Array<Observable<string[]>> = [];
	sortOptions: Array<Observable<string[]>> = [];
	tabHeadersMaxWidth!: number;

	saveViewActions = [];

	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;
	OPERATOR_OPTIONS = OPERATOR_OPTIONS;
	OPERATORS = OPERATORS;
	LOAD_VOLUME_DURATION = LOAD_VOLUME_DURATION;

	USA_STATES = USA_STATES;
	LOCATION_OPERATORS_LABEL = LOCATION_OPERATORS_LABEL;
	STAGE_OPERATORS_LABEL = STAGE_OPERATORS_LABEL;
	JOB_STATUS_OPERATORS_LABEL = JOB_STATUS_OPERATORS_LABEL;
	ARCHIVED_OPERATORS_LABEL = ARCHIVED_OPERATORS_LABEL;
	EQUAL_NOT_EQUAL_TYPES_LABEL = EQUAL_NOT_EQUAL_TYPES_LABEL;
	PROJECT_STAGES: Array<any> = PROJECT_STAGES;
	PROJECT_TYPES: any = PROJECT_TYPES;
	BULK_CAPACITY_MATCH_JOBS_STATUS = BULK_CAPACITY_MATCH_JOBS_STATUS;
	IMPORT_STATS_JOBS_STATUS = IMPORT_STATS_JOBS_STATUS;
	PROJECT_OPERATORS_LABEL = PROJECT_OPERATORS_LABEL;

	// actions for bulk upload
	AUTOMATION_LOADS = AUTOMATION_LOADS;

	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;

	removeContainerHorizontalPadding: boolean = false;

	constructor(
		private formBuilder: FormBuilder,
		private activeRoute: ActivatedRoute,
		public accountSettings: AccountSettingsService,
		public utilService: UtilService,
		public projectHelperService: ProjectHelperService,
		public productsService: ProductsService,
		public readonly store: Store<State>,
		private router: Router,
		private urlService: UrlService,
		private restService: RestService,
		public dialog: MatDialog,
		private breakpointObserver: BreakpointObserver
	) {
		this.trailerTypes = this.accountSettings.SEARCHABLE_TRAILER_TYPES;
		this.breakpointObserver
			.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium])
			.subscribe((result) => {
				this.removeContainerHorizontalPadding =
					result.breakpoints[Breakpoints.XSmall] ||
					result.breakpoints[Breakpoints.Small] ||
					result.breakpoints[Breakpoints.Medium];
			});
	}

	ngOnInit(): void {
		if (IS_NULL_OR_UNDEFINED(this.activeLink)) {
			this.activeLink = this.links[0];
		}

		this.filterForm = this.formBuilder.group({
			formArray: this.formBuilder.array([
				this.formBuilder.group({
					filterField: new FormControl(''),
					filterText: '',
					filterCondition: '',
					operator: '',
					startValue: '',
					endValue: '',
					isNotDeletable: false,
				}),
			]),
		});

		this.sortForm = this.formBuilder.group({
			sortFormArray: this.formBuilder.array([
				this.formBuilder.group({
					sortField: new FormControl(''),
					direction: this.defaultDirection,
				}),
			]),
		});

		this.filterForm.valueChanges.subscribe((val) => {
			this.isAddConditionActive = this.hasMoreCondition();
			this.isFilterButtonActive = this.hasAnyFilter();
		});

		this.sortForm.valueChanges.subscribe((val) => {
			this.isAddFieldActive = this.hasMoreSort();
			this.isSortButtonActive = this.hasAnySorting();
		});

		this.setLocationModel();

		this.addFilterOptions();
		this.addSortOptions();

		this.buildSaveViewActions();
	}

	buildSaveViewActions() {
		this.saveViewActions = [
			{
				label: 'Save New View',
				action: () => {
					const dialogRef = this.dialog.open(ConfirmTextDialogComponent, {
						width: '400px',
						panelClass: 'cargo_chief_dialog_container',
						data: {
							title: 'Save a new view',
							placeholder: 'Tab Name',
							errorMessage: 'Failed to save custom tab',
						},
					});

					dialogRef.afterClosed().subscribe((result) => {
						if (!this.utilService.isNullOrUndefined(result) && result) {
							this.saveCustomFilter(result.trim());
						}
					});
				},
				disabled: () => {
					return false;
				},
			},
			{
				label: 'Update View',
				action: () => {
					this.saveCustomFilter(this.activeLink.trim(), true);
				},
				disabled: () => {
					return this.activeLink === this.links[0];
				},
			},
		];
	}

	setLocationModel() {
		this.filterFieldsInputTypeMap.forEach((field, value) => {
			if (field === INPUT_TYPES.LOCATION) {
				this.locationModel[`${value}0`] = '';
			}
		});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['data'] && changes['data'].currentValue) {
			this.dataSource = new MatTableDataSource<Object>(this.data);
			if (this.isStaticData) {
				this.dataSource.paginator = this.paginator;
			}

			this.selection = new SelectionModel<Object>(true, []);
			this.isActionbuttonDisabled = true;
			if (this.showTabBars && this.links.length) {
				setTimeout(() => {
					this.setTabHeadersMaxWidth();
				}, 100);
			}
		}
	}

	ngAfterViewInit() {
		if (this.isStaticData) {
			this.dataSource.paginator = this.paginator;
		}
		this.paginator.pageIndex = IS_NULL_OR_UNDEFINED(this.activeRoute.snapshot?.queryParams?.page)
			? 0
			: this.activeRoute.snapshot.queryParams.page;

		this.paginator.pageSize = IS_NULL_OR_UNDEFINED(this.activeRoute.snapshot?.queryParams?.pageSize)
			? 25
			: this.activeRoute.snapshot.queryParams.pageSize;
	}

	get formArray() {
		return this.filterForm.get('formArray') as FormArray;
	}

	get sortFormArray() {
		return this.sortForm.get('sortFormArray') as FormArray;
	}

	isNumberField(index: number): boolean {
		let result = false;
		let selected = this.sortFormArray.at(index).get('sortField').value;
		result =
			this.dataTypes[this.displayedColumns.indexOf(this.fieldMap[selected]) - 1] === 'number';
		if (
			IS_NOT_EMPTY(selected) &&
			this.filterFieldsInputTypeMap?.get(selected) === INPUT_TYPES.NUMBER
		) {
			result = true;
		}
		return result;
	}

	changeActiveLink(link: string) {
		if (this.activeLink !== link) {
			if (this.isStaticData) this.loadingData = true;
			this.activeLink = link;
			this.resetFilterAndSort();
			this.updateData.emit(link);
		}
		this.paginator.pageIndex = 0;
	}

	emitPageEvent() {
		this.loadingData = true;
		this.pageEvent.emit({
			page: this.paginator.pageIndex,
			pageSize: this.paginator.pageSize,
		});
	}

	hasMoreCondition(): boolean {
		if (
			this.formArray.length > 1 &&
			this.formArray.at(1).get('filterCondition').value?.length < 1
		) {
			return false;
		}

		for (let i = 0; i < this.formArray.length; i++) {
			const isFilterInputTypeWithStartAndEndValue =
				this.formArray.at(i).get('operator').value === OPERATORS.BETWEEN;
			let isInvalidValue = true;
			if (!isFilterInputTypeWithStartAndEndValue) {
				isInvalidValue = this.formArray.at(i).get('filterText').value?.length < 1;
			} else {
				const startValue = this.formArray.at(i).get('startValue')?.value,
					endValue = this.formArray.at(i).get('endValue')?.value;
				isInvalidValue = IS_NULL_OR_UNDEFINED(startValue) || IS_NULL_OR_UNDEFINED(endValue);
			}
			if (this.formArray.at(i).get('filterField')?.value?.length < 1 || isInvalidValue) {
				return false;
			}
		}

		return true;
	}

	hasMoreSort(): boolean {
		if (this.sortFormArray.length > this.sortFields.length - 1) {
			return false;
		}

		for (let i = 0; i < this.sortFormArray.length; i++) {
			if (
				this.sortFormArray.at(i).get('sortField').value.length < 1 ||
				this.sortFormArray.at(i).get('direction').value.length < 1
			) {
				return false;
			}
		}

		return true;
	}

	hasAnyFilter(): boolean {
		for (let i = 0; i < this.formArray.length; i++) {
			const filterText = this.formArray.at(i).get('filterText').value,
				filterField = this.formArray.at(i).get('filterField').value,
				startValue = this.formArray.at(i).get('startValue')?.value,
				endValue = this.formArray.at(i).get('endValue')?.value,
				operator = this.formArray.at(i).get('operator')?.value;
			if (
				(filterField?.length > 0 &&
					((typeof filterText === 'string' && filterText?.length > 0) ||
						(typeof filterText === 'object' &&
							IS_NOT_NULL_OR_UNDEFINED(filterText) &&
							Object.keys(filterText).length > 0))) ||
				(this.filterFieldsInputTypeMap?.get(filterField || '') === 'date' &&
					(IS_NULL_OR_UNDEFINED(startValue) || IS_NULL_OR_UNDEFINED(endValue)))
			) {
				return true;
			}
			if (
				this.filterFieldsInputTypeMap?.get(filterField || '') === INPUT_TYPES.DATE &&
				startValue &&
				endValue
			) {
				return true;
			} else if (
				this.filterFieldsInputTypeMap?.get(filterField || '') === 'boolean' &&
				IS_NOT_NULL_OR_UNDEFINED(filterText)
			) {
				return true;
			} else if (this.filterFieldsInputTypeMap?.get(filterField) === INPUT_TYPES.NUMBER) {
				if (
					operator === OPERATORS.BETWEEN &&
					typeof startValue !== 'string' &&
					typeof endValue !== 'string' &&
					IS_NOT_NULL_OR_UNDEFINED(startValue) &&
					IS_NOT_NULL_OR_UNDEFINED(endValue)
				) {
					return true;
				}
				if (
					operator !== OPERATORS.BETWEEN &&
					typeof filterText !== 'string' &&
					IS_NOT_NULL_OR_UNDEFINED(filterText)
				) {
					return true;
				}
			} else if (this.filterFieldsInputTypeMap?.get(filterField) === INPUT_TYPES.VOLUME) {
				if (operator === OPERATORS.BETWEEN && filterText && startValue && endValue) {
					return true;
				}
				if (operator !== OPERATORS.BETWEEN && filterText && startValue) {
					return true;
				}
			}
		}

		return false;
	}

	hasAnySorting(): boolean {
		for (let i = 0; i < this.sortFormArray.length; i++) {
			if (
				this.sortFormArray.at(i).get('sortField').value.length > 0 &&
				this.sortFormArray.at(i).get('direction').value.length > 0
			) {
				return true;
			}
		}

		return false;
	}

	addFilter() {
		this.formArray.push(
			this.formBuilder.group({
				filterField: new FormControl(''),
				filterText: '',
				filterCondition: '',
				startValue: '',
				endValue: '',
				operator: '',
				isNotDeletable: false,
			})
		);

		this.addFilterOptions();
	}

	removeFilter(filterIndex: number) {
		this.formArray.removeAt(filterIndex);
		this.removeFilterOptions(filterIndex);
	}

	addSort() {
		this.sortFormArray.push(
			this.formBuilder.group({
				sortField: new FormControl(''),
				direction: this.defaultDirection,
			})
		);

		this.addSortOptions();
	}

	removeSort(index: number) {
		this.sortFormArray.removeAt(index);
		this.removeSortOptions(index);
	}

	clearFilters() {
		this.formArray.value.forEach((filter, index) => {
			if (!filter.isNotDeletable) {
				this.formArray.removeAt(index);
				this.removeFilterOptions(index);
			}
		});
		if (!this.formArray.value.length) {
			this.addFilter();
			this.filterState = '';
		}

		if (!this.isStaticData) {
			this.emitClearFilter.emit(this.activeLink);
		}
		this.dataSource.data = this.data;
		this.triggers.toArray()[0].togglePopover();
	}

	clearSort() {
		while (this.sortFormArray.length !== 0) {
			this.sortFormArray.removeAt(0);
			this.removeSortOptions(0);
		}
		this.addSort();
		this.sortState = '';

		if (!this.isStaticData) {
			this.emitClearSort.emit(this.activeLink);
		}
		this.dataSource.data = this.data;
		this.triggers.toArray()[1].togglePopover();
	}

	filterData() {
		if (this.isStaticData) {
			this.dataSource.data = this.data;

			this.loadingData = true;
			if (this.defaultCondition === 'and') {
				for (let i = 0; i < this.formArray.length; i++) {
					let filterField = this.formArray.at(i).get('filterField').value;
					let filterText = this.formArray.at(i).get('filterText').value.trim().toLowerCase();
					if (filterField.length > 0 && filterText.length > 0) {
						this.dataSource.data = this.dataSource.data.filter(
							(element) =>
								element[this.fieldMap[filterField]]?.trim()?.toLowerCase().indexOf(filterText) > -1
						);
					}
				}
			} else {
				this.dataSource.data = this.dataSource.data.filter((element) => {
					for (let i = 0; i < this.formArray.length; i++) {
						let filterField = this.formArray.at(i).get('filterField').value;
						let filterText = this.formArray.at(i).get('filterText').value.trim().toLowerCase();
						if (filterField.length > 0 && filterText.length > 0) {
							if (
								element[this.fieldMap[filterField]]?.trim()?.toLowerCase().indexOf(filterText) > -1
							)
								return true;
						}
					}
					return false;
				});
			}
			this.loadingData = false;
		} else {
			this.emitFilter.emit(this.formArray.value);
		}
		this.filterState = this.getFilterState();
		this.triggers.toArray()[0].togglePopover();
	}

	sortData() {
		if (this.isStaticData) {
			this.loadingData = true;
			for (let i = this.sortFormArray.length - 1; i >= 0; i--) {
				let sortField = this.sortFormArray.at(i).get('sortField').value;
				let sortDirection = this.sortFormArray.at(i).get('direction').value;
				this.dataSource.data = this.dataSource.data.sort((a, b) => {
					return this.compare(
						a[this.fieldMap[sortField]].trim().toLowerCase(),
						b[this.fieldMap[sortField]].trim().toLowerCase(),
						sortDirection === this.defaultDirection
					);
				});
			}
			this.loadingData = false;
		} else {
			this.emitSort.emit(this.sortFormArray.value);
		}
		this.sortState = this.getSortState();
		this.triggers.toArray()[1].togglePopover();
	}

	compare(a: number | string, b: number | string, isAsc: boolean) {
		return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
	}

	getFilterState(): string {
		let count = 0;
		let field = '';
		if (!this.formArray?.length) {
			this.filterState = '';
			return field;
		}
		for (let i = 0; i < this.formArray.length; i++) {
			let filterField = this.formArray.at(i).get('filterField').value,
				filterText = '',
				operator = this.formArray.at(i).get('operator')?.value,
				startValue = this.formArray.at(i).get('startValue')?.value,
				endValue = this.formArray.at(i).get('endValue')?.value,
				inputType = this.filterFieldsInputTypeMap?.get(filterField),
				isInputValid = false,
				fieldValue = this.formArray.at(i).get('filterText')?.value;

			if (filterField === PROJECT_FIELDS.CUSTOMER) {
				filterText = this.formArray.at(i).get('filterText')?.value?.name?.trim();
			} else if (filterField === PROJECT_FIELDS.ASSIGNED_REPS) {
				filterText = this.formArray.at(i).get('filterText').value;
				isInputValid = true;
			} else if (inputType === 'boolean') {
				filterText = this.formArray.at(i).get('filterText').value ? 'true' : 'false';
			} else if (typeof this.formArray.at(i).get('filterText')?.value === 'string') {
				filterText = this.formArray.at(i).get('filterText').value.trim();
			} else if (filterField === PROJECT_FIELDS.STAGE) {
				filterText = this.formArray.at(i).get('filterText').value;
				isInputValid = true;
			} else if (filterField === PROJECT_FIELDS.TYPE) {
				filterText = this.formArray.at(i).get('filterText').value;
				isInputValid = true;
			} else if (filterField === LOADS_AUTOMATION_FIELDS.JOB_STATUS) {
				filterText = this.formArray.at(i).get('filterText').value;
				isInputValid = true;
			} else if (filterField === LOADS_AUTOMATION_FIELDS.USER) {
				filterText = this.formArray.at(i).get('filterText').value;
				isInputValid = true;
			} else if (filterField === PROJECT_FIELDS.CARRIER) {
				const carrier = this.formArray.at(i).get('filterText')?.value;
				filterText = GET_CARRIER_BUSINESS_NAME(carrier?.businessName, carrier?.doingBusinessAs);
			}

			// check if valid input number
			if (inputType === INPUT_TYPES.NUMBER) {
				filterText = this.formArray.at(i).get('filterText')?.value;
				if (operator === OPERATORS.BETWEEN && startValue && endValue) {
					isInputValid = true;
				}
				if (operator !== OPERATORS.BETWEEN && filterText) {
					isInputValid = true;
				}
			} else if (inputType === INPUT_TYPES.STRING && filterText?.length && operator) {
				isInputValid = true;
			} else if (inputType === INPUT_TYPES.DATE) {
				isInputValid = true;
			} else if (inputType === INPUT_TYPES.VOLUME) {
				filterText = this.formArray.at(i).get('filterText')?.value;
				if (operator === OPERATORS.BETWEEN && filterText && startValue && endValue) {
					isInputValid = true;
				}
				if (operator !== OPERATORS.BETWEEN && filterText && startValue) {
					isInputValid = true;
				}
			} else if (
				(inputType === INPUT_TYPES.LOCATION ||
					inputType === INPUT_TYPES.CUSTOMER ||
					inputType == INPUT_TYPES.CARRIER) &&
				Object.keys(fieldValue || {}).length > 0
			) {
				isInputValid = true;
			} else if (inputType === INPUT_TYPES.TRAILER_TYPE) {
				isInputValid = true;
			} else if (inputType === INPUT_TYPES.STATE) {
				isInputValid = true;
			} else if (filterField === PROJECT_FIELDS.ARCHIVED) {
				filterText = this.formArray.at(i).get('filterText').value;
				isInputValid = true;
			}

			if (filterField?.length > 0 && isInputValid) {
				count++;
				if (field === '') {
					field = filterField;
				}
			}
		}
		return '(' + (count > 1 ? count.toString() : field) + ')';
	}

	getSortState(): string {
		let count = 0;
		let field = '';
		if (!this.sortFormArray?.length) {
			this.sortState = '';
			return field;
		}
		for (let i = 0; i < this.sortFormArray.length; i++) {
			let sortField = this.sortFormArray.at(i).get('sortField').value;
			let sortDirection = this.sortFormArray.at(i).get('direction').value;
			if (sortField.length > 0 && sortDirection.length > 0) {
				count++;
				if (field === '') {
					field = sortField;
				}
			}
		}
		return '(' + (count > 1 ? count.toString() : field) + ')';
	}

	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.dataSource.data.length;
		return numSelected === numRows;
	}

	masterToggle() {
		if (this.isAllSelected()) {
			this.isActionbuttonDisabled = true;
			this.selection.clear();
			return;
		}
		this.isActionbuttonDisabled = false;

		if (this.rowCheckboxIsDisabled) {
			let selectableRows = [];
			this.dataSource.data.forEach((row) => {
				if (!this.rowCheckboxIsDisabled(row)) {
					selectableRows.push(row);
				}
			});

			if (selectableRows.length === this.selection.selected.length) {
				this.selection.clear();
			} else {
				this.selection.select(...selectableRows);
			}
		} else {
			this.selection.select(...this.dataSource.data);
		}
	}

	selectRow(row: Object) {
		this.selection.toggle(row);
		if (this.rowOnSelect) {
			this.rowOnSelect(row, this.selection.isSelected(row));
		}
		if (this.selection.selected.length > 0) {
			this.isActionbuttonDisabled = false;
		} else {
			this.isActionbuttonDisabled = true;
		}
	}

	setLocationValue(value, form): void {
		form.get('filterText').setValue(value?.city);
	}

	setAssignedUsersValue(value, form): void {
		form.get('filterText').setValue(value);
	}

	setCustomer(value, form): void {
		form.get('filterText').setValue(value);
	}

	setCarrier(value, form): void {
		form.get('filterText').setValue(value);
	}

	setProject(value, form): void {
		form.get('filterText').setValue(value);
	}

	onFilterFieldSelection(filterIndex: number): void {
		const filterField = this.formArray.at(filterIndex).get('filterField').value,
			fieldOperatorInputType = this.filterFieldsInputTypeMap?.get(filterField);
		if (fieldOperatorInputType === INPUT_TYPES.DATE) {
			this.formArray.at(filterIndex).get('startValue')?.setValue(new Date());
			this.formArray.at(filterIndex).get('endValue')?.setValue(new Date());
			this.formArray.at(filterIndex).get('operator')?.setValue(OPERATORS.BETWEEN);
		}
		if (
			fieldOperatorInputType == INPUT_TYPES.NUMBER ||
			fieldOperatorInputType === INPUT_TYPES.STRING
		) {
			this.formArray.at(filterIndex).get('operator').setValue(OPERATORS.EQUAL);
			this.formArray.at(filterIndex).get('filterText').setValue(null);
		}
		if (this.filterFieldsInputTypeMap?.get(filterField) === INPUT_TYPES.TRAILER_TYPE) {
			this.formArray.at(filterIndex).get('operator').setValue('');
		}
		if (this.filterFieldsInputTypeMap?.get(filterField) === INPUT_TYPES.VOLUME) {
			this.formArray.at(filterIndex).get('operator').setValue(OPERATORS.EQUAL);
			this.formArray.at(filterIndex).get('filterText').setValue('');
			this.formArray.at(filterIndex).get('endValue').setValue(null);
			this.formArray.at(filterIndex).get('startValue').setValue(null);
		}
		if (fieldOperatorInputType === INPUT_TYPES.BOOLEAN) {
			this.formArray.at(filterIndex).get('operator').setValue(null);
			this.formArray.at(filterIndex).get('filterText').setValue(null);
		}
		if (fieldOperatorInputType === INPUT_TYPES.LOCATION) {
			this.locationModel[filterField + filterIndex] = '';
		}
	}

	dateRangeUpdated(event: SelectedDateRange, form) {
		if (event.startDate && event.endDate) {
			const date: any = {
				startDate: event.startDate,
				endDate: event.endDate,
			};
			form.get('startValue').setValue(date.startDate);
			form.get('endValue').setValue(date.endDate);
		}
	}

	filterOptionsForFilterFields(value: string): string[] {
		const filterValue = value.toLowerCase();

		return this.filterFields.filter((option) => option.toLowerCase().includes(filterValue));
	}

	addFilterOptions() {
		this.filterOptions.push(
			this.formArray
				.at(this.formArray.length - 1)
				.get('filterField')
				.valueChanges.pipe(
					startWith(''),
					map((value) => this.filterOptionsForFilterFields(value || ''))
				)
		);
	}

	removeFilterOptions(index: number) {
		this.filterOptions.splice(index, 1);
	}

	filterOptionsForSortFields(value: string): string[] {
		const filterValue = value.toLowerCase();

		return this.sortFields.filter((option) => option.toLowerCase().includes(filterValue));
	}

	addSortOptions() {
		this.sortOptions.push(
			this.sortFormArray
				.at(this.sortFormArray.length - 1)
				.get('sortField')
				.valueChanges.pipe(
					startWith(''),
					map((value) => this.filterOptionsForSortFields(value || ''))
				)
		);
	}

	removeSortOptions(index: number) {
		this.sortOptions.splice(index, 1);
	}

	trailerTypeKeyPress(searchTerm: string, filterText, formArrayIndex: number) {
		if (!Array.isArray(filterText)) {
			filterText = [];
		}
		const result = this.utilService.detect(searchTerm, filterText);
		this.formArray.at(formArrayIndex).get('filterText').setValue(result);
	}

	importProjectsClicked() {
		this.importData.emit();
	}

	newProjectClicked() {
		this.createData.emit();
	}

	setFilterTextForInvalidFilterField(form, filterTrigger: MatAutocompleteTrigger): void {
		if (!this.filterFieldsInputTypeMap?.get(form.value?.filterField) || '') {
			filterTrigger?.closePanel();
			form.get('filterText').setValue('');
			setTimeout(() => {
				filterTrigger?.openPanel();
			}, 0);
		}
	}

	saveCustomFilter(tabName: string, isUpdate: boolean = false) {
		const url = this.urlService.saveUserSortsAndFilters();
		let filtersList = [].concat(this.formArray.value);
		if (this.userSortsAndFiltersType === USER_SORTS_AND_FILTERS_TYPE.LOADS) {
			let filter = {};
			if (this.isActiveTab) {
				filter['isActiveTab'] = this.isActiveTab;
			} else if (this.isOpenTab) {
				filter['isOpenTab'] = this.isOpenTab;
			} else if (this.isBookedTab) {
				filter['isBookedTab'] = this.isBookedTab;
			}
			filtersList = [filter].concat(filtersList);
		}

		let filterData = JSON.stringify(filtersList);
		let sortData = JSON.stringify(this.sortFormArray.value);

		if (tabName.length > 1) {
			if (
				this.sortFormArray.length === 1 &&
				this.sortFormArray.at(0).get('sortField').value.length < 1
			) {
				sortData = '[]';
			}

			const payload = {
				id: isUpdate ? this.customTabId : null,
				type: this.userSortsAndFiltersType,
				name: tabName,
				filter: filterData,
				sort: sortData,
			};
			this.restService.POST(url, payload).subscribe(
				(response: any) => {
					this.utilService.showSnackbar(
						'Custom tab saved successfully',
						SNACKBAR.SUCCESS,
						SNACKBAR.ACTION
					);
					this.getUserSortsAndFilters();
				},
				(error) => {
					this.utilService.showSnackbar(
						'Failed to save custom tab',
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
				}
			);
		} else {
			this.utilService.showSnackbar(
				'Please provide a name to your custom tab',
				SNACKBAR.ERROR,
				SNACKBAR.ACTION
			);
		}
	}

	firstAction() {
		if (this.actions.length > 0) {
			return this.actions[0];
		}
		return null;
	}

	setTabHeadersMaxWidth(): void {
		const tabHeadersList = document.getElementsByClassName('cc_tab_headers'),
			tabHeadersActions = document.getElementById('cc_tab_headers_actions'),
			matDataTableContainer = document.getElementById('mat_data_table');
		if (tabHeadersList?.length) {
			let maxWidth = 0;
			for (let tabIndex = 0; tabIndex < 3; tabIndex++) {
				if (tabHeadersList[tabIndex]?.clientWidth) {
					maxWidth += tabHeadersList[tabIndex].clientWidth;
				}
			}
			if (tabHeadersActions && matDataTableContainer) {
				const actionsWidth = tabHeadersActions.offsetWidth,
					tableWidth = matDataTableContainer.offsetWidth;
				if (tableWidth > actionsWidth + maxWidth) {
					this.tabHeadersMaxWidth = tableWidth - (actionsWidth + 8);
				} else {
					this.tabHeadersMaxWidth = maxWidth ? maxWidth + 20 : null;
				}
			}
		}
	}

	resetFilterAndSort() {
		while (this.formArray.length !== 0) {
			this.formArray.removeAt(0);
			this.removeFilterOptions(0);
		}
		this.addFilter();
		this.filterState = '';
		while (this.sortFormArray.length !== 0) {
			this.sortFormArray.removeAt(0);
			this.removeSortOptions(0);
		}
		this.addSort();
		this.sortState = '';
	}

	onProjectOperatorChange(event, form) {
		if (event?.value === OPERATORS.NOT_EXIST) {
			form.get('filterText').setValue([]);
		}
		if (!Array.isArray(form.get('filterText').value)) {
			form.get('filterText').setValue([]);
		}
	}
}
